module.exports = __webpack_public_path__ + "img/26.b46f07ed.jpg";